"use strict";

import React, {useEffect, useState} from 'react';
import asyncScriptLoader from 'async-script-loader'

const WistiaInlineEmbed = ({videoId='',
                        embedOptions={},
                        containerOptions='',
                    }) => {

    const [isReady, setIsReady] = useState(false);
    const [videoHandle, setVideoHandle] = useState(null);

    useEffect(()=>{
        asyncScriptLoader('//fast.wistia.com/assets/external/E-v1.js')
            .then(() => {
                const id = videoId;
                window._wq = window._wq || [];
                window._wq.push({
                    id: id,
                    options: embedOptions,
                    onEmbedded: (video) => {
                        setVideoHandle(video);
                    },
                });
                setIsReady(id);
            })
            .catch(err => console.log(err))
    }, []);

    useEffect(()=>{
        if(!!videoHandle)
            videoHandle.pause();
    }, [videoHandle]);


    return (
        <React.Fragment>
            { !!isReady &&
            <div className="wistia_responsive_padding" style={{padding:'56.25% 0 0 0',position:'relative'}}>
                <div className="wistia_responsive_wrapper"
                     style={{height:'100%',left:'0',position:'absolute',top:'0',width:'100%',}}>
                    <div className={`wistia_embed wistia_async_${videoId} videoFoam=true ${containerOptions}`}
                         style={{height:'100%',position:'relative',width:'100%',}}>&nbsp;</div>
                </div>
            </div>
            }
        </React.Fragment>
    );
};

export default WistiaInlineEmbed;
